export default __webpack_public_path__ + "static/media/about-vision-text.96544533.svg";